export default __webpack_public_path__ + "static/media/UTPL_Fiscal_2024.5555691c.pdf";